"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const react_redux_1 = require("react-redux");
const styles_1 = __importDefault(require("../../styles/styles"));
const FieldErrorMessageComponent_1 = __importDefault(require("../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const themes_1 = __importDefault(require("../../styles/themes"));
const communicationBoxUtils_1 = require("../communicationBox/communicationBoxUtils");
const communicationSlice_1 = require("../communicationBox/communicationSlice");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const PhoneNumberField = () => {
    const { phoneNumber, voipProvider } = useAppSelector_1.default((state) => ({
        phoneNumber: state.communication.phoneNumber,
        voipProvider: state.auth.user.current_voip_provider,
    }));
    const dispatch = react_redux_1.useDispatch();
    const [phoneNumberError, setPhoneNumberError] = react_1.useState('');
    const updateCustomPhoneNumber = (text) => {
        const formattedPhoneNumber = communicationBoxUtils_1.formatPhoneNumber(text);
        const error = communicationBoxUtils_1.validatePhoneNumber(formattedPhoneNumber.substring(4));
        setPhoneNumberError(error);
        dispatch(communicationSlice_1.updatePhoneNumber({ phoneNumber: formattedPhoneNumber, isValidPhoneNumber: !error }));
    };
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_paper_1.TextInput, { label: `phone number (${voipProvider && voipProvider.display_value})`, placeholder: "Enter phone number", left: true, style: [styles_1.default.customPhoneInput, styles_1.default.textInput, { height: 60 }], onChangeText: updateCustomPhoneNumber, value: phoneNumber, theme: themes_1.default.textInput }),
        !!phoneNumberError && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginLeftThirty, styles_1.default.marginBottomTen] },
            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: phoneNumberError })))));
};
exports.default = PhoneNumberField;
